module.exports = __webpack_public_path__ + "static/media/3 2 tattoo back divine powerful intricate mythical vibrant.1121x1535.0f2187a6.webp";